export const FontWeights = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
} as const;

export type FontWeight = typeof FontWeights;
